import moment from "moment";

export default function formatDate(date) {
  if (!date) return null;

  return moment(new Date(date)).format("YYYY-MM-DD");
}
